import { useEffect, useRef } from 'react'

/**
 * Marks the element while none of it is on screen (`[data-offscreen]` in app.css), so the page's endless loops cost
 * nothing once scrolled past, which matters most on a phone: animations pause, and the demo loops stop outright to
 * give up their layers. The attribute is set on the node directly: toggling it must not re-render anything.
 */
export function usePauseOffscreen<T extends Element>() {
  const ref = useRef<T>(null)
  useEffect(() => {
    const node = ref.current
    if (!node) return
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) node.toggleAttribute('data-offscreen', !entry.isIntersecting)
    })
    observer.observe(node)
    return () => observer.disconnect()
  }, [])
  return ref
}
